export default [
  {
    path: 'quote-agreement',
    name: 'quoteAgreement',
    component: () => import('@/views/pages/quote-agreement/QuoteAgreement.vue'),
    meta: {
      pageTitle: 'Quote Agreement',
      breadcrumb: [
        {
          text: 'Quote Agreement',
          active: true,
        },
      ],
      resource: 'QuoteAgreement',
    },
  },
]
